// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field--outlined[data-v-207c3bd5] fieldset{border-color:var(--v-primary300-base)!important;border-width:2px!important}", ""]);
// Exports
module.exports = exports;
